export default "__VITE_ASSET__D6O7Ytm4__"